
import * as React from 'react';

interface IProps {
    leftHeader: React.ReactNode;
    rightHeader: React.ReactNode;
    activeTab: Tab;
    onPressTab(tab: Tab): void;
    leftComponent(): JSX.Element;
    rightComponent(): JSX.Element;
    containerStyle?: React.CSSProperties;
    tabStyle?: React.CSSProperties;
    style?: React.CSSProperties;
}

export enum Tab {
    RIGHT = 'right',
    LEFT = 'left'
}


export class CommonTabbedContainer extends React.Component<IProps> {
    public render() {
        const fontStyle = (tab: Tab): any => {
            return tab === this.props.activeTab ? styles.activeTab : styles.inactiveTab;
        };

        return (
            <div style={{ ...styles.fullWidth, ...this.props.style }}>
                <div style={{ ...styles.container, ...this.props.containerStyle }}>
                    <div style={{ ...styles.tab, ...this.props.tabStyle, ...styles.tabFont, ...fontStyle(Tab.LEFT) }}
                         onClick={() => this.props.onPressTab(Tab.LEFT)}>
                        {this.props.leftHeader}
                        {this.props.activeTab === Tab.LEFT && <div style={styles.activeIndicator} />}
                    </div>
                    <div style={{ ...styles.tab, ...this.props.tabStyle, ...styles.tabFont, ...fontStyle(Tab.RIGHT) }}
                         onClick={() => this.props.onPressTab(Tab.RIGHT)}>
                        {this.props.rightHeader}
                        {this.props.activeTab === Tab.RIGHT && <div style={styles.activeIndicator} />}
                    </div>
                </div>
                {this.props.activeTab === Tab.RIGHT && this.props.rightComponent()}
                {this.props.activeTab === Tab.LEFT && this.props.leftComponent()}
            </div>
        );
    }
}

const styles = {
    fullWidth: {
        width: '100%'
    },
    container: {
        display: 'flex',
        height: 55,
        width: '100%',
        backgroundColor: '#FAFAFA',
        cursor: 'pointer'
    },
    tab: {
        display: 'flex',
        height: '100%',
        flex: 1,
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center'
    } as React.CSSProperties,
    tabFont: {
        width: '100%',
        textAlign: 'center',
        color: '#48A29B',
    },
    activeIndicator: {
        height: 4,
        width: '100%',
        backgroundColor: '#48A29B',
        position: 'absolute',
        bottom: 0
    } as React.CSSProperties,
    inactiveTab: {
        fontWeight: 100,
        opacity: 0.6
    },
    activeTab: {
        fontWeight: 900
    }
};



// WEBPACK FOOTER //
// ./src/SharedComponents/CommonTabbedContainer.tsx